import {useTranslation} from "react-i18next";
import SideBlock from "../SideBlock";
import Description from "./MainBlockParts/Description";
import {Switch, NavLink} from "react-router-dom";
import Program from "./MainBlockParts/Program";
import UserProgram from "./MainBlockParts/UserProgram";
import Speakers from "./MainBlockParts/Speakers";
import Reports from "./MainBlockParts/Reports";
import Author from "./MainBlockParts/Author";
import Report from "./MainBlockParts/Report";
import {useAuth} from "../../../services/use-auth";
import GuardedRoute from "../../Route/GuardedRoute";

export default function MainBlock(
    {
        id,
        description,
        organizers,
        countriesParticipants,
        phones,
        emails,
        sites,
        dateStart,
        dateEnd,
        locations,
        hasChildEvents
    }
) {
    const { t } = useTranslation();
    const auth = useAuth();

    return (
        <div className="conference-grid">
            <div className="about-conference">
                <div className="conference-tabs">
                    <div className="menu-scrollable">
                        <div className="nav-tabs">
                            { !!description && <NavLink exact to={`/conference/${id}`} activeClassName="active">
                                { t('conferences.conference.tabs.description') }
                            </NavLink> }
                            {
                                !hasChildEvents &&
                                    <>
                                        <NavLink exact to={`/conference/${id}/program`} activeClassName="active">
                                            { t('conferences.conference.tabs.program') }
                                        </NavLink>
                                        <NavLink to={`/conference/${id}/speakers`} activeClassName="active">
                                            { t('conferences.conference.tabs.speakers') }
                                        </NavLink>
                                        <NavLink to={`/conference/${id}/reports`} activeClassName="active">
                                            { t('conferences.conference.tabs.reports') }
                                        </NavLink>
                                        { auth.user && <NavLink exact to={`/conference/${id}/myProgram`} activeClassName="active">
                                            { t('conferences.conference.tabs.myProgram') }
                                        </NavLink> }
                                    </>
                            }

                        </div>
                    </div>
                    <div className="tabs-content-horisontal">
                        <Switch>
                            <GuardedRoute
                                exact
                                path={`/conference/${id}`}
                            >
                                <Description
                                    description={description}
                                />
                            </GuardedRoute>
                            <GuardedRoute
                                exact
                                path={`/conference/${id}/program`}
                                authRequired
                            >
                                <Program
                                    id={id}
                                />
                            </GuardedRoute>
                            <GuardedRoute
                                exact
                                path={`/conference/${id}/speakers`}
                                authRequired
                            >
                                <Speakers
                                    id={id}
                                />
                            </GuardedRoute>
                            <GuardedRoute
                                exact
                                path={`/conference/${id}/reports`}
                                authRequired
                            >
                                <Reports
                                    id={id}
                                />
                            </GuardedRoute>
                            <GuardedRoute
                                exact
                                path={`/conference/${id}/myProgram`}
                                authRequired
                            >
                                <UserProgram
                                    id={id}
                                />
                            </GuardedRoute>
                            <GuardedRoute
                                exact
                                path={`/conference/${id}/speakers/:authorId`}
                                authRequired
                            >
                                <Author
                                    id={id}
                                />
                            </GuardedRoute>
                            <GuardedRoute
                                exact
                                path={`/conference/${id}/reports/:reportId`}
                                authRequired
                            >
                                <Report
                                    id={id}
                                />
                            </GuardedRoute>
                        </Switch>

                    </div>
                </div>
            </div>
            <SideBlock
                id={id}
                organizers={organizers}
                countriesParticipants={countriesParticipants}
                phones={phones}
                emails={emails}
                sites={sites}
                dateStart={dateStart}
                dateEnd={dateEnd}
                locations={locations}
            />
        </div>
    );
}
